import axios from "axios";
const back_url = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem("token");
const apiClient = axios.create({
  baseURL: back_url,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;

export const createCheckoutSession = async (priceId: any) => {
  try {
    const response = await apiClient.post(
      "/subscription/create-checkout-session",
      { price_id: priceId }
    );
    return response.data.payload.checkout_url;
  } catch (error) {
    console.error("Error creating checkout session:", error);
    throw error;
  }
};

export const updatePlanAction = async (priceId: any) => {
  try {
    const response = await apiClient.post("/subscription/update-plan", {
      price_id: priceId,
    });
    if (response.data && response.data.status === "success") {
      return response.data;
    }
  } catch (error) {
    console.error("Error downgrading plan:", error);
    throw error;
  }
};
